/* tslint:disable */
/* eslint-disable */
export enum BankStatementSourceEnum {
  IllionBrokerFlow = 'IllionBrokerFlow',
  CreditSense = 'CreditSense',
  Pdf = 'Pdf',
  ProvideLater = 'ProvideLater',
  SendLink = 'SendLink'
}
